import {
  Component,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { SuiToasterComponent } from '@stride-ui/components';
import { LanguageService, RobotsMetaService } from '@tnq/shared/core';
import { environment } from '../environments/environment';

@Component({
  imports: [RouterModule, SuiToasterComponent],
  selector: 'tnq-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  readonly languageService = inject(LanguageService);
  private readonly robotsMetaService = inject(RobotsMetaService);

  ngOnInit(): void {
    this.languageService.initialize();
    this.robotsMetaService.initialize(environment);
  }
}
